module.exports = __webpack_public_path__ + "img/vm1-ultra.119719bb.jpg";